(function(){
  'use strict';
  function qs(sel,root){return (root||document).querySelector(sel)}
  function qsa(sel,root){return Array.prototype.slice.call((root||document).querySelectorAll(sel))}
  function escapeHtml(v){var d=document.createElement('div');d.textContent=v==null?'':String(v);return d.innerHTML}
  function setVal(root,name,value){var el=qs('[data-pet-prop="'+name+'"]',root); if(el) el.value=value||''}
  function openModal(id){if(window.FlorDeOroCustomizer&&typeof window.FlorDeOroCustomizer.open==='function')window.FlorDeOroCustomizer.open(id);else{var m=document.getElementById(id);if(m){m.classList.add('is-open');m.setAttribute('aria-hidden','false')}}}
  function closeModal(id){if(window.FlorDeOroCustomizer&&typeof window.FlorDeOroCustomizer.close==='function')window.FlorDeOroCustomizer.close(id);else{var m=document.getElementById(id);if(m){m.classList.remove('is-open');m.setAttribute('aria-hidden','true')}}}

  function init(root){
    if(!root||root.dataset.petStudioReady==='true')return; root.dataset.petStudioReady='true';
    var modalId=root.getAttribute('data-pet-modal');
    var animal=root.getAttribute('data-pet-animal')||'pet';
    var textOnly=root.getAttribute('data-pet-text-only')==='true';
    var form=root.closest('form');
    var activeSide='front', step=1;
    var state={
      front:{mode:textOnly?'Typography':'Portrait Art',style:'Minimal line-art',font:'Elegant script',breed:'',text:'',name:'',whatsapp:false,file:null,fileName:'',fileUrl:''},
      back:{mode:'Typography',style:'Minimal line-art',font:'Elegant script',breed:'',text:'',name:'',whatsapp:false,file:null,fileName:'',fileUrl:''}
    };
    var fileInputs={front:qs('[data-pet-file="front"]',root),back:qs('[data-pet-file="back"]',root)};
    var summary=qs('[data-pet-summary]',root), summaryBody=qs('[data-pet-summary-body]',root);
    function modal(){return document.getElementById(modalId)}
    function scope(){return modal()||root}
    function qall(sel){return qsa(sel,scope()).concat(qsa(sel,root)).filter(function(el,i,arr){return arr.indexOf(el)===i})}
    function one(sel){return qs(sel,scope())||qs(sel,root)}
    function S(){return state[activeSide]}
    function cap(s){return s==='front'?'Front':'Back'}
    function propName(side,label){return cap(side)+' '+label}
    function showError(msg){qsa('[data-pet-error]',root).concat(qsa('[data-pet-inline-error]',scope())).forEach(function(e){if(e){e.textContent=msg;e.classList.add('is-visible')}})}
    function clearError(){qsa('[data-pet-error]',root).concat(qsa('[data-pet-inline-error]',scope())).forEach(function(e){e.textContent='';e.classList.remove('is-visible')})}

    function sideHasAnyInput(sideKey){
      var s=state[sideKey];
      return !!(s.file || s.whatsapp || String(s.text||'').trim() || String(s.name||'').trim() || String(s.breed||'').trim());
    }
    function collectVisible(){
      var side=S();
      var text=one('[data-pet-input="text"]'), name=one('[data-pet-input="cat-name"]'), note=one('[data-pet-input="note"]'), wa=one('[data-pet-whatsapp-photo]');
      if(text) side.text=text.value;
      if(name) side.name=name.value;
      if(wa) side.whatsapp=!!wa.checked;
      if(note) setVal(root,'Designer note',note.value);
    }
    function writeAllProps(){
      ['front','back'].forEach(function(sideKey){var s=state[sideKey];
        var backBlank = sideKey==='back' && !sideHasAnyInput('back');
        setVal(root,propName(sideKey,'creation style'),backBlank?'Blank / no engraving':s.mode);
        setVal(root,propName(sideKey,'photo status'),s.file?'Uploaded':(s.whatsapp?'Will be sent by WhatsApp':''));
        setVal(root,propName(sideKey,'send photo by WhatsApp'),s.whatsapp?'Yes':'No');
        setVal(root,propName(sideKey,'pet name'),s.name);
        setVal(root,propName(sideKey,'artwork style'),s.style);
        setVal(root,propName(sideKey,'selected illustration'),s.breed);
        setVal(root,propName(sideKey,'typography text'),s.text);
        setVal(root,propName(sideKey,'font style'),s.font);
      });
      setVal(root,'Active preview side',cap(activeSide));
    }
    function syncVisible(){
      var s=S(); var imgs=qall('[data-pet-preview-img]'); var text=one('[data-pet-preview-text]');
      qall('[data-pet-side]').forEach(function(btn){btn.classList.toggle('is-active',btn.getAttribute('data-pet-side')===activeSide)});
      qall('[data-pet-side-title]').forEach(function(el){el.textContent=cap(activeSide)});
      /* Fix #5: update step-1 heading subtitle to reflect chosen mode */
      var step1Title=one('[data-pet-step="1"] .fdo-pet-section-title');
      if(step1Title){
        var modeSubtitles={'Portrait Art':'upload a memory','Typography':'add your text','Curated Cats':'choose an illustration'};
        step1Title.innerHTML='<span data-pet-side-title>'+cap(activeSide)+'</span>: '+(modeSubtitles[s.mode]||'choose creation style');
      }
      var label=one('[data-pet-active-side-label]'); if(label) label.textContent='Designing '+activeSide+' side';
      qall('[data-pet-mode]').forEach(function(btn){btn.classList.toggle('is-active',btn.getAttribute('data-pet-mode')===s.mode)});
      qall('[data-pet-panel]').forEach(function(panel){panel.classList.toggle('is-active',panel.getAttribute('data-pet-panel')===s.mode)});
      var text=one('[data-pet-input="text"]'), name=one('[data-pet-input="cat-name"]'), wa=one('[data-pet-whatsapp-photo]'), uploaded=one('[data-pet-uploaded-name]');
      if(text) text.value=s.text||'';
      if(name) name.value=s.name||'';
      if(wa) wa.checked=!!s.whatsapp;
      if(uploaded) uploaded.textContent=s.fileName||'';
      qall('[data-pet-style]').forEach(function(btn){btn.classList.toggle('is-active',btn.getAttribute('data-pet-style')===s.style)});
      qall('[data-pet-font]').forEach(function(btn){btn.classList.toggle('is-active',btn.getAttribute('data-pet-font')===s.font)});
      qall('[data-pet-breed]').forEach(function(btn){btn.classList.toggle('is-active',btn.getAttribute('data-pet-breed')===s.breed)});
      qall('.fdo-pet-upload-preview').forEach(function(box){box.classList.toggle('has-image',!!s.fileUrl)});
      renderPreview(); renderReview(); writeAllProps();
    }
    function renderBreedSvgToPreview(breedName, textEl){
      /* Find the breed card (may be inside the modal, now in body) */
      var breedCard = document.querySelector('[data-pet-breed="'+breedName+'"]');
      var breedVisual = breedCard ? breedCard.querySelector('.fdo-pet-breed-visual') : null;
      var svgEl = breedVisual ? breedVisual.querySelector('svg') : null;
      if(svgEl && textEl){
        textEl.innerHTML='';
        textEl.appendChild(svgEl.cloneNode(true));
        var noteEl=document.createElement('span');
        noteEl.className='fdo-pet-preview-note';
        noteEl.textContent=cap(activeSide)+': '+escapeHtml(breedName);
        textEl.appendChild(noteEl);
        return true;
      }
      return false;
    }
    function renderPreview(){
      var s=S(); var imgs=qall('[data-pet-preview-img]'); var text=one('[data-pet-preview-text]');
      if(activeSide==='back' && !sideHasAnyInput('back')){
        imgs.forEach(function(img){img.hidden=true});
        if(text){text.hidden=false;text.innerHTML='<span class="fdo-pet-preview-text">Blank</span><span class="fdo-pet-preview-note">Back: no engraving selected</span>';}
        return;
      }
      if(s.mode==='Portrait Art'){
        imgs.forEach(function(img){if(s.fileUrl){img.src=s.fileUrl;img.hidden=false}else{img.hidden=true}});
        if(text){
          if(s.fileUrl){text.hidden=true;}
          else{text.hidden=false;text.innerHTML='<span class="fdo-pet-preview-text">Your '+escapeHtml(animal)+'</span><span class="fdo-pet-preview-note">'+cap(activeSide)+': photo line-art</span>';}
        }
      }else if(s.mode==='Curated Cats'){
        imgs.forEach(function(img){img.hidden=true});
        if(text){
          text.hidden=false;
          if(s.breed){
            /* Try to copy the actual SVG artwork into the pendant preview */
            var rendered=renderBreedSvgToPreview(s.breed,text);
            if(!rendered){
              text.innerHTML='<span class="fdo-pet-preview-text">'+escapeHtml(s.breed)+'</span><span class="fdo-pet-preview-note">'+cap(activeSide)+': selected illustration</span>';
            }
          }else{
            text.innerHTML='<span class="fdo-pet-preview-text">Artwork</span><span class="fdo-pet-preview-note">Choose an illustration below</span>';
          }
        }
      }else{
        imgs.forEach(function(img){img.hidden=true});
        if(text){text.hidden=false;text.innerHTML='<span class="fdo-pet-preview-text">'+escapeHtml(s.text||s.name||(animal==='baby'?'Emma':'Milo'))+'</span><span class="fdo-pet-preview-note">'+cap(activeSide)+': typography</span>';}
      }
    }
    function validateSide(sideKey){
      var s=state[sideKey];
      if(sideKey==='back' && !sideHasAnyInput('back')) return '';
      if(s.mode==='Portrait Art'&&!s.file&&!s.whatsapp)return 'Please add a photo for the '+sideKey+' side, or choose the WhatsApp photo option.';
      if(s.mode==='Typography'&&!String(s.text||'').trim())return 'Please add the text for the '+sideKey+' side.';
      if(s.mode==='Curated Cats'&&!s.breed)return 'Please choose an illustration for the '+sideKey+' side.';
      return '';
    }
    function validateCurrent(){collectVisible(); return validateSide(activeSide)}
    function validateAll(){collectVisible(); return validateSide('front')||validateSide('back')}
    function renderReview(){
      var review=one('[data-pet-review]'); if(!review)return; writeAllProps();
      var rows=[];
      ['front','back'].forEach(function(sideKey){var s=state[sideKey]; var detail=s.mode;
        if(sideKey==='back' && !sideHasAnyInput('back')) detail='Blank / no engraving';
        else if(s.mode==='Portrait Art') detail += s.file?' · photo uploaded':(s.whatsapp?' · photo by WhatsApp':' · photo missing');
        else if(s.mode==='Typography') detail += s.text?' · '+s.text:' · text missing';
        else if(s.mode==='Curated Cats') detail += s.breed?' · '+s.breed:' · illustration missing';
        rows.push([cap(sideKey),detail]);
      });
      review.innerHTML=rows.map(function(l){return '<div class="fdo-pet-review-line"><span>'+escapeHtml(l[0])+'</span><span>'+escapeHtml(l[1])+'</span></div>'}).join('');
    }
    function setStep(next){
      step=Math.max(1,Math.min(3,next)); clearError();
      qall('[data-pet-step]').forEach(function(panel){panel.classList.toggle('is-active',parseInt(panel.getAttribute('data-pet-step'),10)===step)});
      qall('[data-pet-progress]').forEach(function(btn){var n=parseInt(btn.getAttribute('data-pet-progress'),10);btn.classList.toggle('is-active',n===step);btn.classList.toggle('is-done',n<step)});
      qall('[data-pet-back]').forEach(function(btn){btn.hidden=step===1});
      qall('[data-pet-next]').forEach(function(btn){btn.hidden=step===3});
      qall('[data-pet-save]').forEach(function(btn){btn.hidden=step!==3});
      syncVisible(); var scroller=qs('.fdo-pet-work-scroll',scope()); if(scroller) scroller.scrollTop=0;
    }
    function saveCreation(){
      var msg=validateAll(); if(msg){showError(msg); activeSide=msg.indexOf('back')>-1?'back':'front'; setStep(2); return}
      writeAllProps(); root.setAttribute('data-pet-saved','true');
      if(summary&&summaryBody){summaryBody.innerHTML=['Front: '+state.front.mode,'Back: '+(!sideHasAnyInput('back')?'Blank / no engraving':state.back.mode)].map(function(l){return '<span>'+escapeHtml(l)+'</span>'}).join(''); summary.hidden=false;}
      closeModal(modalId);
    }
    document.addEventListener('click',function(e){
      var btn=e.target.closest('[data-pet-side],[data-pet-mode],[data-pet-style],[data-pet-font],[data-pet-breed],[data-pet-choose-file],[data-pet-progress],[data-pet-next],[data-pet-back],[data-pet-save],[data-pet-edit]');
      if(!btn)return; var inModal=scope().contains(btn), inRoot=root.contains(btn); if(!inModal&&!inRoot)return;
      if(btn.matches('[data-pet-side]')){e.preventDefault();collectVisible();activeSide=btn.getAttribute('data-pet-side');root.setAttribute('data-pet-saved','false');syncVisible();return}
      if(btn.matches('[data-pet-mode]')){e.preventDefault();S().mode=btn.getAttribute('data-pet-mode');root.setAttribute('data-pet-saved','false');syncVisible();return}
      if(btn.matches('[data-pet-style]')){e.preventDefault();S().style=btn.getAttribute('data-pet-style');root.setAttribute('data-pet-saved','false');syncVisible();return}
      if(btn.matches('[data-pet-font]')){e.preventDefault();S().font=btn.getAttribute('data-pet-font');root.setAttribute('data-pet-saved','false');syncVisible();return}
      if(btn.matches('[data-pet-breed]')){e.preventDefault();S().breed=btn.getAttribute('data-pet-breed');root.setAttribute('data-pet-saved','false');syncVisible();return}
      if(btn.matches('[data-pet-choose-file]')){e.preventDefault();var input=fileInputs[activeSide]; if(input)input.click();return}
      if(btn.matches('[data-pet-progress]')){e.preventDefault();var target=parseInt(btn.getAttribute('data-pet-progress'),10); if(target>step && step===2){var msg=validateCurrent(); if(msg){showError(msg);return}} setStep(target);return}
      if(btn.matches('[data-pet-next]')){e.preventDefault(); if(step===2){var msg2=validateCurrent(); if(msg2){showError(msg2);return}} setStep(step+1);return}
      if(btn.matches('[data-pet-back]')){e.preventDefault();setStep(step-1);return}
      if(btn.matches('[data-pet-save]')){e.preventDefault();saveCreation();return}
      if(btn.matches('[data-pet-edit]')){e.preventDefault();openModal(modalId);return}
    });
    document.addEventListener('input',function(e){if(scope().contains(e.target)&&e.target.matches('[data-pet-input]')){collectVisible();root.setAttribute('data-pet-saved','false');renderPreview();renderReview()}});
    document.addEventListener('change',function(e){if(scope().contains(e.target)&&e.target.matches('[data-pet-whatsapp-photo]')){collectVisible();root.setAttribute('data-pet-saved','false');renderReview()}});
    ['front','back'].forEach(function(sideKey){var input=fileInputs[sideKey]; if(!input)return; input.addEventListener('change',function(){if(input.files&&input.files.length){state[sideKey].file=input.files[0];state[sideKey].fileName=input.files[0].name;state[sideKey].fileUrl=URL.createObjectURL(input.files[0]);} root.setAttribute('data-pet-saved','false'); if(activeSide===sideKey)syncVisible(); writeAllProps();})});
    if(form){form.addEventListener('submit',function(e){if(root.getAttribute('data-pet-saved')==='true')return;e.preventDefault();e.stopPropagation();showError('Please save your front design before adding this personalized piece to cart.');openModal(modalId)},true)}
    syncVisible(); setStep(1);
  }
  function boot(){qsa('[data-fdo-pet-studio-root]').forEach(init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();